import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
var useLogEvents = function useLogEvents() {
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var sessionOpenAddGuestListLogEvent = function sessionOpenAddGuestListLogEvent(_ref) {
    var sessionId = _ref.sessionId,
      sessionType = _ref.sessionType,
      sessionTime = _ref.sessionTime;
    logEvent({
      event: 'Session Open Add Guest List',
      data: _objectSpread({
        'Session ID': sessionId,
        'Session Type': sessionType,
        'Session Time': sessionTime
      }, getSourceEventParams())
    });
  };
  var sessionOpenRegisterAttendanceListLogEvent = function sessionOpenRegisterAttendanceListLogEvent(_ref2) {
    var sessionId = _ref2.sessionId,
      sessionType = _ref2.sessionType;
    logEvent({
      event: 'Session Open Register Attendance List',
      data: _objectSpread({
        'Session ID': sessionId,
        'Session Type': sessionType
      }, getSourceEventParams())
    });
  };
  return {
    sessionOpenAddGuestListLogEvent: sessionOpenAddGuestListLogEvent,
    sessionOpenRegisterAttendanceListLogEvent: sessionOpenRegisterAttendanceListLogEvent
  };
};
export default useLogEvents;